// material-ui
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

// assets
import logoDark from 'assets/logo-dark.png';
import logoLight from 'assets/logo-light.png';

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain() {
  const theme = useTheme();
  return (
    <img src={theme.palette.mode === 'dark' ? logoDark : logoLight} alt="Bizora" width="100" />
  );
}
